import * as _ from "lodash";

import { CreditRequestRowType } from "../context/CreditRequestContext";
import { CreditRequestStatus } from "../api/credit-request.api";

export const creditRequestCount = (credits: CreditRequestRowType[], type: "approved" | "requested"): number => {
  return _.reduce(credits, (currentTotal, cred) => {
    if (cred.status === CreditRequestStatus.Rejected) {
      return currentTotal;
    }

    if (type === "requested") {
      return currentTotal + cred.quantityRequested;
    } else {
      return currentTotal + (cred.quantityApproved || 0);
    }
  }, 0);
};
